module.exports = __webpack_public_path__ + "media/src/assets/save_filled-7e4cd124c995deb02a6d554e2b9ff504.svg";